/**
 * メールアドレスの検証
 * @param email メールアドレス
 * @returns メールアドレスが有効かどうか
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email === "" || emailRegex.test(email);
};

/**
 * 必須項目の検証
 * @param value 必須項目の値
 * @returns 必須項目が入力されているかどうか
 */
export const validateRequired = (value: string): boolean => {
  return value.trim() !== "";
};

/**
 * 電話番号の検証
 * @param tel 電話番号
 * @returns 電話番号が有効かどうか
 */
export const validateTel = (tel: string): boolean => {
  // Basic phone number validation - allows common formats
  const telRegex = /^[0-9\-()\s]+$/;
  return tel === "" || telRegex.test(tel);
};

/**
 * 利益配分率の検証
 * @param rate 利益配分率
 * @returns 利益配分率が有効かどうか
 */
export const validateProfitShareRate = (rate: number): boolean => {
  return rate >= 0 && rate <= 100;
};
